import { EventEmitter, Injectable, Output } from '@angular/core';

@Injectable({
  providedIn: 'root'
})
export class UploadImageService {

  @Output() saveImageTrigger: EventEmitter<string> = new EventEmitter();
  
  doUpload(actionFrom:string) { 
    this.saveImageTrigger.emit(actionFrom);
  }
}
